module.exports = __webpack_public_path__ + "b954346c127c42284968ddf5d4d38b1c.svg";